import { useStreamingAvatarStore } from "@/features/avatar/lib/useStreamingAvatarStore";

export const useConnectionQuality = () => {
    const { connectionQuality } = useStreamingAvatarStore();

    return {
        connectionQuality,
    };
};
